import Photo from './models'

export default Photo
